<template>
  <div style=" width: 1200px; margin: 0 auto; background-color: #F2F6FC;  ">
    <Title :title="{name: '费用报销申请',path:'/item'}"></Title>

    <el-card class="box-card" style="min-height: 650px;margin-top: 15px">
      <el-divider content-position="left">报销信息</el-divider>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="left" label-width="120px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="报销类型" prop="projectOrOffice" required>
              <el-radio-group v-model="ruleForm.projectOrOffice">
                <el-radio label="1">项目费用</el-radio>
                <el-radio label="2">管理费用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item v-if="ruleForm.projectOrOffice==1" label="报销项目" prop="projectId" required>
              <el-select style="width: 100%" v-model="ruleForm.projectId" placeholder="请选择报销项目" filterable>
                <el-option
                  v-for="item in projectList"
                  :key="item.projectId"
                  :label="item.projectName"
                  :value="item.projectId"
                  :disabled="item.projectState === 6"
                  @click.native="projectChange(item.projectName)">
                  <span style="float: left">{{ item.projectName }}&nbsp&nbsp{{item.projectIden}}</span>&nbsp&nbsp
                  <el-tag v-if="item.projectState === 6" type="info" size="mini">S: 已终止</el-tag>
                  <span style="float: left">&nbsp&nbspM: {{ item.managerName }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="报销名目" prop="reimburseType">
              <el-select v-model="ruleForm.reimburseType" placeholder="请选择报销名目">
                <el-option value="1" label="交通费"></el-option>
                <el-option value="9" label="路桥费"></el-option>
                <el-option value="2" label="油费"></el-option>
                <el-option value="3" label="招待费"></el-option>
                <el-option value="4" label="住宿费"></el-option>
                <el-option value="5" label="餐补"></el-option>
                <el-option value="6" label="办公费"></el-option>
                <el-option value="11" label="福利费"></el-option>
                <el-option value="10" label="礼品费"></el-option>
                <el-option value="12" label="卡劵"></el-option>
                <el-option value="8" label="其他" :disabled="ruleForm.projectOrOffice==1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12" v-if="ruleForm.projectOrOffice==1&&ruleForm.reimburseType==3">
            <el-form-item label="所属招待" prop="costReportId">
              <el-select style="width: 100%" v-model="ruleForm.costReportId" placeholder="请选择所属招待" filterable>
                <el-option
                  v-for="item in costReportList"
                  :key="item.costReportId"
                  :label="item.projectName"
                  :value="item.costReportId"
                  :disabled="item.isSubmit === 3">
                  <span style="float: left">{{ item.projectName }}&nbsp&nbsp{{item.projectIden}}</span>
                  <el-tag v-if="item.isSubmit !== 3" size="mini" effect="dark" type="warning"
                    style="float: right; margin-top: 8px"
                    @click.stop="handleDetail(item, $event)">
                    查看详情
                  </el-tag>
                  <el-tag v-if="item.isSubmit === 3" size="mini" effect="dark" type="info"
                    style="float: right; margin-top: 8px">
                    存在报销
                  </el-tag>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="报销模式" prop="reimburseMode">
              <el-radio-group v-model="ruleForm.reimburseMode">
                <el-radio label="1">统一报销(多人同行)</el-radio>
                <el-radio label="2">独立报销(单人外出)</el-radio>
              </el-radio-group>

              <template v-if="ruleForm.reimburseMode === '1'">
                <!-- 提示 -->
                <el-alert
                    title="温馨提示:自驾出行同行人费用统一由车主报销"
                    type="warning"
                    show-icon
                    :closable="false"
                    style="margin-bottom: 5px;margin-top: 5px"
                />
              </template>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="报销金额" prop="reimburseMoney">
          <el-input v-model="ruleForm.reimburseMoney" placeholder="请输入报销金额" maxlength="12">
            <template slot="append">{{ getDigitUppercase }}</template>
          </el-input>
        </el-form-item>

        <el-form-item label="费用产生时间" prop="spendTime">
          <el-date-picker
            v-model="ruleForm.spendTime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm"
            type="datetime"
            placeholder="请选择费用产生时间">
          </el-date-picker>
        </el-form-item>

        <el-row :gutter="20" v-if="ruleForm.reimburseType==1||ruleForm.reimburseType==2">
          <el-col :span="12">
            <el-form-item label="出发地" prop="originAddress">
              <el-input v-model="ruleForm.originAddress" placeholder="请输入出发地">
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="目的地" prop="endAddress">
              <el-input v-model="ruleForm.endAddress" placeholder="请输入目的地">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="费用事由" prop="remarks">
          <el-input size="" type="textarea" v-model="ruleForm.remarks"
                    placeholder="请输入费用事由">
          </el-input>
        </el-form-item>

        <el-Form-item>
          <el-button type="success" @click="addItem('ruleForm')">新增报销项</el-button>
        </el-Form-item>
      </el-form>

      <el-table
        :data="draftList"
        :cell-style="{color: 'black'}">
        <el-table-column fixed prop="projectOrOffice" label="报销类型" width="220px" align="center">
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.projectOrOffice==1">项目费用</span>
              <span v-if="scope.row.projectOrOffice==2">管理费用</span>
            </div>
            <div v-if="scope.row.projectOrOffice==1">
              <div>{{ scope.row.projectName }}</div>
              <el-button plain type="primary" size="mini"
                @click="handleProjectDetail(scope.row.projectId)">项目信息
              </el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="reimburseType"
          label="报销名目"
          align="center"
          width="120px">
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.reimburseType==1">交通费</span>
              <span v-if="scope.row.reimburseType==9">路桥费</span>
              <span v-if="scope.row.reimburseType==2">油费</span>
              <span v-if="scope.row.reimburseType==3">招待费</span>
              <span v-if="scope.row.reimburseType==4">住宿费</span>
              <span v-if="scope.row.reimburseType==5">餐补</span>
              <span v-if="scope.row.reimburseType==6">办公费</span>
              <span v-if="scope.row.reimburseType==7">办公费</span>
              <span v-if="scope.row.reimburseType==10">礼品费</span>
              <span v-if="scope.row.reimburseType==11">福利费</span>
              <span v-if="scope.row.reimburseType==8">其他</span>
            </div>
            <span v-if="scope.row.projectOrOffice==1 && scope.row.reimburseType==3" style="color: #409EFF">
              <el-button plain type="primary" size="mini"
                @click="handleCostReportDetail(scope.row.costReportId)">招待详情</el-button>
            </span>
          </template>
        </el-table-column>
        <el-table-column
            prop="reimburseMode"
            label="报销模式"
            align="center"
            width="80px">
          <template slot-scope="scope">
            <span v-if="scope.row.reimburseMode==1">统一报销</span>
            <span v-if="scope.row.reimburseMode==2">独立报销</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="reimburseMoney"
          label="报销金额"
          align="center"
          width="150px">
          <template slot-scope="scope">
            <span>￥{{ scope.row.reimburseMoney }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="spendTime"
          label="费用产生时间"
          align="center"
          width="170px">
        </el-table-column>

        <el-table-column prop="spendTime" label="外出信息" align="center">
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.originAddress">出发地:{{ scope.row.originAddress }}</span>
              <span v-else>出发地:无</span>
            </div>
            <div>
              <span v-if="scope.row.endAddress">目的地:{{ scope.row.endAddress }}</span>
              <span v-else>出发地:无</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          prop="remarks"
          label="费用事由"
          align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.remarks">{{ scope.row.remarks }}</span>
            <span v-else>无</span>
          </template>
        </el-table-column>

        <el-table-column fixed="right" align="center" label="操作" width="220">
          <template slot-scope="scope">
            <el-popconfirm
              title="确定删除该报销项？"
              @confirm="handleDelete(scope.row.reimburseId)">
              <el-button style="margin-right: 2px" slot="reference" size="mini" type="danger">
                删除
              </el-button>
            </el-popconfirm>
            <el-popconfirm title="确定修改报销项？" @confirm="handleBack(scope.row)">
              <el-button slot="reference" size="mini" type="warning">
                修改
              </el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>

      <div style="float:right;margin-top: 15px;margin-right: 20px;clear: both;">总金额: ￥{{ single.reimburseMoney }}元</div>
      <div style="clear: both"></div>
      <el-button v-if="submitShow" style="margin-top: 20px;margin-left: 120px"
        type="primary" @click="submitForm('ruleForm')">提交申请</el-button>
    </el-card>

    <el-dialog title="查看详情" :visible.sync="detailShow" width="30%">
      <el-form label-position="left" label-width="120px">
        <el-divider content-position="left">报备信息</el-divider>

        <el-form-item label="报备项目">
          <el-input v-model="costReport.projectName" disabled>
          </el-input>
        </el-form-item>

        <el-form-item label="报备类型">
          <el-radio-group v-model="costReport.costType" disabled>
            <el-radio label="1" readonly>餐饮</el-radio>
            <el-radio label="2" readonly>烟</el-radio>
            <el-radio label="3" readonly>酒</el-radio>
            <el-radio label="4" readonly>礼品</el-radio>
            <el-radio label="5" readonly>其他</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="消费时间">
          <el-date-picker
              disabled
              v-model="costReport.useTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm"
              type="datetime"
              readonly
              placeholder="请选择消费时间">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="预估金额" prop="costMoney">
          <el-input disabled v-model="costReport.costMoney" maxlength="12">
          </el-input>
        </el-form-item>

        <el-form-item label="申请事由" prop="reportSubject">
          <el-input readonly type="textarea" rows="5" maxlength="500" show-word-limit v-model="costReport.reportSubject"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="detailShow = false">取 消</el-button>
        <el-button type="primary" @click="handleDetailConfirm">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="项目信息" :visible.sync="projectShow" width="1200px">
      <ProjectDialog :projectId="projectId" :key="uuid"></ProjectDialog>
    </el-dialog>

    <el-dialog title="招待费报备详情" :visible.sync="costReportShow" width="1200px">
      <CostReportDialog :costReportId="costReportId" :key="uuid"></CostReportDialog>
    </el-dialog>

    <el-dialog title="报销信息" :visible.sync="reimburseShow" width="1200px" v-if="reimburseShow">
      <EditReimburse :editData="editData" :projectList="projectList" @refresh="refresh">
      </EditReimburse>
    </el-dialog>
  </div>

</template>

<script>
import Title from "../../Title";
import {digitUppercase, isNum, uuid} from "../../../util";
import {
  requestAddReimburse, requestAllCostReport,
  requestAllProject,
  requestLastdraft, requestReimburseRemove, requestApplyDetail
} from "../../../api";
import ProjectDialog from "../common/ProjectDialog";
import CostReportDialog from "../common/CostReportDialog";
import EditReimburse from "../common/EditReimburse.vue";

export default {
  components: {CostReportDialog, ProjectDialog, Title, EditReimburse},
  name: "ReimburseApply",
  data() {
    const validatePrice = (rule, value, callback) => {
      if (!value) {
        callback(new Error("金额不能为空"));
      } else if (!isNum(value)) {
        callback(new Error("请输入正确格式的金额"));
      } else if (value.split(".").length > 2) {
        callback(new Error("请输入正确格式的金额")); //防止输入多个小数点
      } else if (value.indexOf(".") > -1 && value.substring(value.indexOf(".") + 1).length > 2) {
        callback(new Error("最大保留两位小数"));
      } else if (value.length > 12) {
        callback(new Error("长度最大12个字符"))
      } else {
        this.ruleForm.reimburseMoney = value
        callback();
      }
    };
    return {
      applyId: "",
      applyServiceId: "",
      applyType: "",
      reapply: false,
      submitShow: true,
      dialogVisible: false,
      projectList: [],
      costReportList: [],
      draftJsonArray: [],
      draftList: [],
      reimburseSingleId: "",
      detailShow: false,
      costReport: {},
      projectShow: false,
      projectId: "",
      costReportShow: false,
      costReportId: "",
      reimburseShow: false,
      editData: {
        projectOrOffice: "1",
        projectName: "",
        reimburseType: "1",
        reimburseMode: "1",
        reimburseMoney: "",
        spendTime: "",
        originAddress: "",
        endAddress: "",
        remarks: "",
        projectShow: false,
        projectId: "",
        costReportShow: false,
        costReportId: "",
      },

      single:{
        reimburseMoney:0,
      },
      uuid : "",

      ruleForm: {
        projectOrOffice: "1",
        projectName: "",
        reimburseType: "1",
        reimburseMode: "1",
        reimburseMoney: "",
        spendTime: "",
        originAddress: "",
        endAddress: "",
        remarks: "",
        projectShow: false,
        projectId: "",
        costReportShow: false,
        costReportId: "",
      },
      rules: {
        reimburseMoney: [
          {required: true, validator: validatePrice, trigger: 'blur'},
        ],
        reimburseMode: [
          { required: true, message: '请选择报销方式', trigger: 'change' }
        ],
        reportSubject: [
          {required: true, message: '请输入申请事由', trigger: 'blur'},
          {max: 500, message: '长度最大500个字符', trigger: 'blur'}
        ],
        projectId: [
          {required: true, message: '请选择报销项目', trigger: 'blur'},
        ],
        reimburseType: [
          {required: true, message: '请选择报销名目', trigger: 'blur'},
        ],
        spendTime: [
          {required: true, message: '请选择费用产生时间', trigger: 'blur'},
        ],
        costReportId: [
          {required: true, message: '请选择所属招待', trigger: 'blur'},
        ],
        remarks: [
          {max: 500, message: '长度最大500个字符', trigger: 'blur'}
        ],
      },
    }
  },
  created() {
    this.applyId = this.$route.query.applyId
    this.applyServiceId = this.$route.query.applyServiceId
    this.applyType = this.$route.query.applyType
    if (this.applyId || this.applyServiceId || this.applyType) {
      this.reapply = true
      this.getObject()
    } else {
      this.getLastDraft()
    }
    this.getAllProject()
    this.getAllCostReport()
  },
  computed: {
    getDigitUppercase() {
      return digitUppercase(this.ruleForm.reimburseMoney)
    },
  },
  methods: {
    handleProjectDetail(projectId) {
      this.projectShow = true
      this.projectId = projectId
      this.uuid = uuid()
    },
    handleCostReportDetail(costReportId) {
      this.costReportShow = true
      this.costReportId = costReportId
      this.uuid = uuid()
    },
    projectChange(projectName) {
      this.ruleForm.projectName = projectName
    },
    handleBack(row) {
      this.editData.reimburseSingleId = this.reimburseSingleId
      this.editData.reimburseId = row.reimburseId
      this.editData.spendTime = row.spendTime
      this.editData.originAddress = row.originAddress
      this.editData.endAddress = row.endAddress
      this.editData.remarks = row.remarks
      this.editData.reimburseMode = row.reimburseMode
      this.editData.reimburseMoney = row.reimburseMoney.toString()
      this.editData.reimburseType = row.reimburseType
      this.editData.projectOrOffice = row.projectOrOffice.toString()
      this.editData.projectId = row.projectId
      this.editData.costReportId = row.costReportId
      document.body.scrollTop = 0
      this.reimburseShow = true
      console.log("editData",this.editData)
    },
    handleDelete(reimburseId) {
      requestReimburseRemove({
        reimburseId: reimburseId
      }).then(res => {
        if (res.code == 200) {
          this.$message.success(res.msg)
          if (this.reapply) {
            this.getObject()
          } else {
            this.getLastDraft()
          }
        } else {
          this.$message.error(res.msg);
        }
        // 重新加载招待项目
        this.getAllCostReport()
      })
    },
    handleDetail(item) {
      console.log(item)
      this.detailShow = true
      this.costReport = item
    },
    handleDetailConfirm() {
      this.detailShow = false
      this.ruleForm.costReportId = this.costReport.costReportId
    },
    // 获取当前用户的报销单草稿
    getLastDraft() {
      requestLastdraft().then(res => {
        if (res.code == 200) {
          if (res.object && res.object.single && res.object.single.reimburseSingleId) {
            this.reimburseSingleId = res.object.single.reimburseSingleId
            this.draftList = res.object.reimburseList
            this.single = res.object.single
          } else {
            this.draftList = []
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    addItem(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let reimburse = {}
          reimburse.projectOrOffice = this.ruleForm.projectOrOffice
          if (this.ruleForm.projectOrOffice == 1) {
            reimburse.projectId = this.ruleForm.projectId
            reimburse.projectName = this.ruleForm.projectName
          }
          reimburse.reimburseType = this.ruleForm.reimburseType
          reimburse.reimburseMode = this.ruleForm.reimburseMode
          reimburse.reimburseMoney = this.ruleForm.reimburseMoney
          reimburse.spendTime = this.ruleForm.spendTime
          if (this.ruleForm.reimburseType == 1 || this.ruleForm.reimburseType == 2) {
            reimburse.originAddress = this.ruleForm.originAddress
            reimburse.endAddress = this.ruleForm.endAddress
          }
          if (this.ruleForm.projectOrOffice == 1 && this.ruleForm.reimburseType == 3) {
            reimburse.costReportId = this.ruleForm.costReportId
          }
          reimburse.remarks = this.ruleForm.remarks
          reimburse.uuid = uuid()

          // 保存到草稿
          let reimburseObj = reimburse
          reimburseObj.type = 1
          reimburseObj.reimburseSingleId = this.reimburseSingleId
          if (this.reapply) {
            reimburseObj.reapply = this.reapply
            reimburseObj.applyId = this.applyId
          }

          requestAddReimburse(reimburseObj).then(res => {
            if (res.code == 200) {
              this.reimburseSingleId = res.object
              this.$message.success(res.msg)
              if (this.reapply) {
                this.getObject()
              } else {
                this.getLastDraft()
              }
              // 重新加载招待项目
              this.getAllCostReport()
              this.ruleForm.costReportId = ""
            } else {
              this.$message.error(res.msg);
            }
          })

        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    submitForm(formName) {
      if (!this.draftList || this.draftList.length == 0) {
        this.$message.error("请填写报销项")
        return
      }

      let reimburseObj = {}
      reimburseObj.type = 2
      reimburseObj.reimburseSingleId = this.reimburseSingleId
      // 重新申请需要的参数
      if (this.reapply) {
        reimburseObj.applyId = this.applyId
        reimburseObj.reapply = this.reapply
      }
      this.submitShow = false

      requestAddReimburse(reimburseObj).then(res => {
        if (res.code == 200) {
          this.reimburseSingleId = ""
          this.$message.success(res.msg)
          // this.draftList = []
          // 重新申请完之后清空路径参数
          if (this.reapply) {
            this.$router.push({query: {}})
            this.reapply = false
          }
          this.getLastDraft()
          this.resetForm('ruleForm')
          this.submitShow = true
          this.single.reimburseMoney = 0
        } else {
          this.$message.error(res.msg);
          this.submitShow = true
        }
      })
    },
    // 获取所有费用申请
    getAllCostReport() {
      requestAllCostReport({}).then(res => {
        if (res.code == 200) {
          if (res.object) {
            this.costReportList = res.object
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    // 查询所有项目
    getAllProject() {
      requestAllProject({}).then(res => {
        if (res.code == 200) {
          if (res.object) {
            this.projectList = res.object
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    getObject() {
      requestApplyDetail({
        applyId: this.applyId,
        applyServiceId: this.applyServiceId,
        applyType: this.applyType
      }).then(res => {
        if (res.code == 200) {
          if (res.object) {
            let detail = res.object.detail
            this.reimburseSingleId = detail.reimburseSingleId
            this.draftList = detail.reimburseList
            this.single.reimburseMoney = detail.reimburseMoney
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    refresh() {
      this.reimburseShow = false
      if (this.reapply) {
        this.getObject()
      } else {
        this.getLastDraft()
      }
      this.getAllCostReport()
    }
  }
}
</script>

<style scoped>

</style>




